import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { PrimeNgModule } from "@primeng";
import { BadgeModule } from "primeng/badge";
import { FormIOInboxIndicatorComponent } from "./formio-inbox-indicator.component";
import { TooltipModule } from "primeng/tooltip";
import { FormIOInboxComponent } from "./formio-inbox.component";
import { GridModule } from "@features/grid";
import { FilterModule } from "@features/filter";
import { BbFormIOModule } from "@features/bb-formio";
import { EpisodeService } from "@project/episode/episode.service";
import { MiproSharedModule } from "@mipro/mipro-shared.module";

@NgModule({
    declarations: [FormIOInboxIndicatorComponent, FormIOInboxComponent],
    imports: [
        CommonModule,
        PrimeNgModule,
        BadgeModule,
        TooltipModule,
        GridModule,
        FilterModule,
        BbFormIOModule,
        MiproSharedModule
    ],
    providers: [EpisodeService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [FormIOInboxIndicatorComponent]
})
export class FormIOInboxModule {}